const suggestionDOTD = function(){
	const accordions = new getAccordions4i();
	const helpers = new formHelpers4i();
	const forms = new forms4i();
	let submitBtn, suggestForm, recaptchaSiteKey, recaptchaActionName;
	
	const init = () => {
		getSuggestPanel();
	},
	getSuggestPanel = async () => {
		let panelHTML;
		try{
			const response = await fetch('/dealoftheday/deals/GetSuggest', {
				method: 'GET', 
				headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch' }
			});
			panelHTML = await response.text();
		}catch(error){
			console.error(error);
			// error function here
		}
		
		if(panelHTML && document.getElementById("suggestPnl")){
			document.getElementById("suggestPnl").innerHTML = panelHTML;
			accordions.init(document.getElementById("suggestPnl"));
			setVariables();
			if (submitBtn) submitBtn.addEventListener("click", validate);
		}
	},
	setVariables = () => {
		suggestForm = document.getElementById("suggestForm");
		submitBtn = document.getElementById("btnSubmitSuggestion");
		recaptchaSiteKey = suggestForm.querySelector("#RecaptchaSiteKeySuggest").value;	
		recaptchaActionName = suggestForm.querySelector("#recaptchaActionNameSuggest").value;
	},
	validate = (e) => {
		e.preventDefault();
		helpers.ClearStatus();
		helpers.ShowBusyBtn(submitBtn);
		submitBtn.setAttribute("disabled", "disabled");
		forms.formValidation(suggestForm, sendSuggestForm, e, enableSubmitBtn);
	},
	enableSubmitBtn = () => {
		submitBtn.removeAttribute("disabled");
		helpers.ClearBusyBtn();
	},
	sendSuggestForm = async () => {
		grecaptcha.execute(recaptchaSiteKey, { action: recaptchaActionName }).then(function (token) {
			submitForm(token);
		});
    },
	submitForm = async (token) => {
		const data = {		
			SenderEmail: suggestForm.querySelector("#SenderEmail").value,
			Suggestion: document.getElementById("Suggestion").value,
			RecaptchaActionName: recaptchaActionName,
			RecaptchaToken: token
		};
		
		let responseJSON;
		try{
			const response = await fetch('/dealoftheday/Deals/Suggest/', {
				method: 'POST', 
				body: JSON.stringify(data),
				headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch' }
			});
			responseJSON = await response.json();
		}catch(error){
			enableSubmitBtn();
			console.error(error);
			helpers.ShowErrorStatus(submitBtn.parentNode, "There was an error processing your suggestion. Please try again.");
		}
		
		enableSubmitBtn();

		if(responseJSON){
			if (responseJSON.success) {
				document.getElementById("suggestForm").querySelector("#SenderEmail").value = "";
				document.getElementById("Suggestion").value = "";
				helpers.ShowSuccessStatus(submitBtn.parentNode, responseJSON.message);
			}else{
				helpers.ShowErrorStatus(submitBtn.parentNode, responseJSON.message);
			}
		}
	};
	return{
		Init: init
	};
};

(function(){
	const suggestion = new suggestionDOTD();
	suggestion.Init();
})();